<template>
    <div id="kpiList">
      <div class="content-header" style="display:none">
        <el-radio-group v-model="teamTab" size="small">
          <el-radio-button label="Patrol">巡查</el-radio-button>
          <el-radio-button label="right">业务</el-radio-button>
        </el-radio-group>
      </div>
    
      <div class="content-body" style="margin-top: 0px;">
       <div class="box">
         <div class="box-header">
           现代
         </div>
         <div class="box-body">
            <ul class="list-group">
                    <li @click="viewDetail('ModernStack','现代-堆头资源占有率')">堆头资源占有率</li>
                    <li @click="viewDetail('ModernAvgGoods','现代-平均铺货品项数')">平均铺货品项数</li>
                    <li @click="viewDetail('ModernDWhite','现代-[日龄]白奶')">[日龄]白奶</li>
                    <li @click="viewDetail('ModernDHigh','现代-[日龄]高端')">[日龄]高端</li>
                    <li @click="viewDetail('ModernDSour','现代-[日龄]常温酸')">[日龄]常温酸</li>
                    <li @click="viewDetail('ModernPWhite','现代-[促销]白奶')">[促销]白奶</li>
                    <li @click="viewDetail('ModernPHigh','现代-[促销]高端')">[促销]高端</li>
                    <li @click="viewDetail('ModernPSour','现代-[促销]常温酸')">[促销]常温酸</li>
                    <li @click="viewDetail('ModernNew','现代-新品铺货')">新品铺货</li>
                </ul>
         </div>
       </div>
       <div class="box">
         <div class="box-header">
           20店
         </div>
         <div class="box-body">
            <ul class="list-group">
                    <li @click="viewDetail('TwentyAvgGoods','20店-平均铺货品项数')">平均铺货品项数</li>
                    <li @click="viewDetail('TwentyBox','20店-整箱达标')">整箱达标</li>
                    <li @click="viewDetail('TwentyNew','20店-新品铺市')">新品铺市</li>
                </ul>
         </div>
       </div>
       <div class="box">
         <div class="box-header">
           MA
         </div>
         <div class="box-body">
            <ul class="list-group">
                    <li @click="viewDetail('MAAvgGoods','MA-平均铺货品项数')">平均铺货品项数</li>
                    <li @click="viewDetail('MABox','MA-整箱达标')">整箱达标</li>
                    <li @click="viewDetail('MANew','MA-新品铺市')">新品铺市</li>
                </ul>
         </div>
       </div>
        <div class="box">
         <div class="box-header">
           大80
         </div>
         <div class="box-body">
            <ul class="list-group">
                    <li @click="viewDetail('EightyAvgGoods','大80-平均铺货品项数')">平均铺货品项数</li>
                    <li @click="viewDetail('EightyGoods','大80-品牌铺市率')">品牌铺市率</li>
                    <li @click="viewDetail('EightyBox','大80-整箱结构')">整箱结构</li>
                </ul>
         </div>
       </div>
      </div>
  
  
    </div>
  </template>
  <script>
  import { message, getBaseUrl} from "../../api/api";
  import libs from "../../utils/libs";
  import moment from "moment";
  import store from "../../utils/storage";
  
  export default {
    data() {
      return {
        teamTab:'Patrol',
        uid:0,
      };
    },
    mounted() {
      this.uid=this.$route.params.uid;
    },
    methods: {
      viewDetail(module,title){
        console.log(title);
        switch(module){
          case 'ModernStack':
            this.$router.push({path:"/ModernStack/"+this.uid+"/"+module+"/"+title});
            break;
          case 'ModernAvgGoods':
            this.$router.push({path:"/ModernAvgGoods/"+this.uid+"/"+module+"/"+title});
            break;
          case 'ModernDWhite':
          case 'ModernDHigh':
          case 'ModernDSour':
            this.$router.push({path:"/ModernDay/"+this.uid+"/"+module+"/"+title});
            break;
          case 'ModernPWhite':
          case 'ModernPHigh':
          case 'ModernPSour':
            this.$router.push({path:"/ModernPromotion/"+this.uid+"/"+module+"/"+title});
            break;
          case 'ModernNew':
            this.$router.push({path:"/ModernNew/"+this.uid+"/"+module+"/"+title});
            break;
           case 'TwentyAvgGoods':
            this.$router.push({path:"/TwentyAvgGoods/"+this.uid+"/"+module+"/"+title});
            break;
           case 'TwentyBox':
            this.$router.push({path:"/TwentyBox/"+this.uid+"/"+module+"/"+title});
            break;
           case 'TwentyNew':
            this.$router.push({path:"/TwentyNew/"+this.uid+"/"+module+"/"+title});
            break;
          case 'MAAvgGoods':
            this.$router.push({path:"/MAAvgGoods/"+this.uid+"/"+module+"/"+title});
            break;
           case 'MABox':
            this.$router.push({path:"/MABox/"+this.uid+"/"+module+"/"+title});
            break;
           case 'MANew':
            this.$router.push({path:"/MANew/"+this.uid+"/"+module+"/"+title});
            break;
            case 'EightyAvgGoods':
            this.$router.push({path:"/EightyAvgGoods/"+this.uid+"/"+module+"/"+title});
            break;
            case 'EightyGoods':
            this.$router.push({path:"/EightyGoods/"+this.uid+"/"+module+"/"+title});
            break;
            case 'EightyBox':
            this.$router.push({path:"/EightyBox/"+this.uid+"/"+module+"/"+title});
            break;
        }
        
        
      },
     
    }
  };
  </script>
  
  <style scoped>
  @import "../../assets/css/kpi/kpi.css";
  </style>


// WEBPACK FOOTER //
// src/components/kpi/KPIList.vue